import { useSyncExternalStore } from "react"

const MOBILE_BREAKPOINT = 768

/**
 * Por debajo de esto el panel del Brain **no cabe al lado** (2.5).
 *
 * No es el ancho del teléfono: es la cuenta de qué queda para el contenido
 * cuando el panel se pone al lado. Con 1.280 px de ventana, el contenido al
 * mínimo son 512 px, y ahí las rejillas de escritorio siguen pintándose a tres
 * columnas —los cortes de Tailwind miran la ventana, no la caja—, así que la
 * pantalla no se rompe: se apelmaza. Por encima de 1.280 el contenido nunca
 * baja de 768 px y al panel le quedan 358, que dan para conversar.
 */
const SIDE_BY_SIDE_BREAKPOINT = 1280

/** La suscripción a una media query, que es la misma para todas. */
function useMediaQuery(query: string): boolean {
  const subscribe = (onStoreChange: () => void) => {
    const mql = getMediaQueryList(query)
    if (!mql) return () => {}

    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", onStoreChange)
      return () => mql.removeEventListener("change", onStoreChange)
    }

    // Safari fallback
    mql.addListener(onStoreChange)
    return () => mql.removeListener(onStoreChange)
  }

  const getSnapshot = () => getMediaQueryList(query)?.matches ?? false

  return useSyncExternalStore(subscribe, getSnapshot, () => false)
}

function getMediaQueryList(query: string): MediaQueryList | null {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return null
  }

  return window.matchMedia(query)
}

export function useIsMobile() {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
}

/** Si hay sitio para poner el panel al lado del contenido en vez de encima. */
export function useFitsSideBySide() {
  return useMediaQuery(`(min-width: ${SIDE_BY_SIDE_BREAKPOINT}px)`)
}
